export const marginContract = {
  marginContract: `ADITIVO AO CONTRATO DE INTERMEDIAÇÃO - CONTA MARGEM

  Pelo presente ADITIVO AO CONTRATO DE INTERMEDIAÇÃO - CONTA MARGEM (ADITIVO), de um lado,
  EASYNVEST - TÍTULO CORRETORA DE VALORES SA (CORRETORA), com sede na Cidade de São Paulo,
  Estado de São Paulo, na Av. Dr. Cardoso de Melo, 1.608 - 14º andar - Vila Olímpia, inscrita
  no CNPJ/MF sob número 62.169.875/0001-79, e o CLIENTE, devidamente cadastrado na CORRETORA,

  Em conjunto denominadas PARTES, celebram o presente ADITIVO, conforme a seguir:

  1. DO OBJETO

  1.1. Este ADITIVO tem por fim regular os direitos e obrigações das PARTES para a concessão de
  financiamento para a compra de ações no mercado à vista (Financiamento), e é incorporado como
  parte integral do ?CONTRATO DE INTERMEDIAÇÃO?, registrado no 4º Oficial de Registro de Títulos
  e Documentos e Civil de Pessoa Jurídica da cidade de São Paulo, sob nº 5.210.856, celebrado
  entre a CORRETORA e o CLIENTE, modificando-o apenas na extensão das cláusulas adicionais aqui
  descritas.

  2. DO MODO OPERACIONAL

  2.1. O CLIENTE autoriza a abertura de conta corrente especial (CONTA MARGEM), sob sua
  titularidade, para o registro de todos os eventos decorrentes das operações objeto do presente
  ADITIVO.

  2.2. Será considerada como operação de Financiamento, toda compra de ativos para cuja liquidação
  o CLIENTE não disponha de recursos financeiros suficientes.

  2.3. O Financiamento concedido deverá ser utilizado exclusivamente na aquisição de ações que
  constem na Relação de Conta Margem divulgada periodicamente pela BM&FBOVESPA S.A. - Bolsa de
  Valores, Mercadorias e Futuros (Bolsa), a qual o CLIENTE declara ter conhecimento e acompanhar
  regularmente.

  2.4. As operações efetuadas com o Financiamento somente poderão ser executadas pela CORRETORA,
  sendo vedado qualquer repasse das referidas operações para outra instituição.

  2.5. Em garantia ao Financiamento, o CLIENTE deverá caucionar à CORRETORA, no momento da
  aquisição, todas as ações adquiridas nas condições do presente ADITIVO, cujo valor, acrescido
  de outras garantias, represente, no mínimo, 150% (cento e cinquenta por cento) do valor do
  Financiamento.

  2.6. O CLIENTE compromete-se a transferir e caucionar, junto à CORRETORA, anteriormente ao
  Financiamento, ativos suficientes para garantir as operações objeto deste ADITIVO, sob pena
  de ter suas operações recusadas.

  2.7. As garantias devem ser de propriedade do CLIENTE, e estar livres e desembaraçadas de
  quaisquer ônus judiciais ou extrajudiciais.

  2.8. As garantias deverão estar autorizadas pela Bolsa e/ou pela CORRETORA para este propósito,
  as quais poderão ser ações, títulos públicos, títulos privados ou outros valores mobiliários
  autorizados.

  2.9. A CORRETORA poderá, ao seu critério, selecionar e recusar os títulos e valores mobiliários
  disponibilizados pelo CLIENTE, que integrarão a carteira de garantia das operações de
  Financiamento, bem como exigir a substituição dos ativos caucionados.

  2.10. Caso a(s) emissora(s) das ações caucionadas determinem a distribuição de proventos, os
  mesmos serão caucionados junto à CORRETORA, como garantia.

  2.11. As garantias caucionadas à CORRETORA, ficarão, até a data da liquidação do Financiamento,
  mantidas na CORRETORA, sendo vedada a sua transferência para quaisquer terceiros.

  2.12. As cauções serão liberadas imediatamente após o pagamento do saldo devedor por elas
  garantido.

  2.13. Na hipótese das garantias deixarem de representar o percentual mínimo de 150% (cento e
    cinquenta por cento), o CLIENTE obriga-se a atender, no prazo máximo de 02 (dois) dias úteis,
    contados a partir do desenquadramento, a reposição, reforço ou substituição das garantias,
    sob pena de rescisão imediata do presente ADITIVO, sem prejuízo de outras penalidades.

  2.14. As garantias serão avaliadas diariamente de acordo com os critérios e metodologia de
  avaliação de garantias da Bolsa e/ou da CORRETORA.

  2.15. O descumprimento pelo CLIENTE, das obrigações na forma ora pactuada, facultará à
  CORRETORA, o direito de proceder à venda, inclusive extrajudicial, dos ativos caucionados
  como garantia ao Financiamento.

  3. DAS DISPOSIÇÕES GERAIS

  3.1. O CLIENTE declara:

  a) concordar com as taxas cobradas pela CORRETORA, divulgadas em seu site
  (www.easynvest.com.br), e acompanhá-las regularmente;

  b) ter conhecimento, acompanhar regularmente e concordar com as informações e especificações
  do produto objeto deste ADITIVO, disponíveis no site da CORRETORA, cujo conteúdo pode ser
  alterado pela CORRETORA, ao seu exclusivo critério, sem a necessidade de aviso prévio ao CLIENTE;

  c) não estar vedado às operações objeto deste ADITIVO, conforme regulação vigente.

  As presentes cláusulas entram em vigor no ato da celebração deste ADITIVO, permanecendo em
  vigor as demais disposições do CONTRATO DE INTERMEDIAÇÃO.`
}

export const rentContract = {
  rentContract: `Pelo presente ADITIVO AO CONTRATO DE INTERMEDIAÇÃO -
  OPERAÇÕES DE EMPRÉSTIMO DE AÇÕES(ADITIVO ), de um lado, EASYNVEST -
  TÍTULO CORRETORA DE VALORES SA ( CORRETORA ), com sede na Cidade de São Paulo,
  Estado de São Paulo, na Av. Dr. Cardoso de Melo, 1.608 - 14º andar - Vila Olímpia,
  inscrita no CNPJ/MF sob número 62.169.875/0001-79; e o CLIENTE , devidamente
  cadastrado na CORRETORA ,



  Em conjunto denominadas PARTES , celebram o presente ADITIVO , conforme a seguir:

  DO OBJETO

  1.1 Este ADITIVO tem por fim regular os direitos e obrigações das PARTES para a realização de
  operações de empréstimo de ações, e é incorporado como parte integral do
  ?CONTRATO DE INTERMEDIAÇÃO?, registrado no 4º Oficial de Registro de Títulos e Documentos e
  Civil de Pessoa Jurídica da cidade de São Paulo, sob nº 5.210.856, celebrado entre a
  CORRETORA e o CLIENTE, modificando-o apenas na extensão das cláusulas adicionais aqui descritas.

  DO MODO OPERACIONAL

  2.1. O CLIENTE autoriza a CORRETORA a representá-lo em operações no Banco de Títulos BMFBOVESPA,
  conforme as Normas definidas no CONTRATO DE INTERMEDIAÇÃO, que venham a ser celebradas em nome
  do CLIENTE, seja na posição doadora ou tomadora de títulos, observadas as condições aqui
  descritas.

  2.2. As ordens do CLIENTE, autorizando operações de empréstimo na qualidade de tomador/doador de
  ativos deverão ser verbais ou por escrito, e conterão, no mínimo, a identificação do emissor, da
  quantidade, espécie e classe dos ativos, o prazo de vigência e a taxa de remuneração pactuada,
  determinando as condições da operação.

  2.3. Antes de iniciar uma operação tomadora de ativos, o CLIENTE deverá efetuar o depósito das
  garantias junto à CORRETORA. A Bolsa e a CORRETORA poderão, a qualquer tempo e ao exclusivo
  critério das mesmas, exigir garantias extras e adicionais. As garantias poderão,
  independentemente de notificação judicial ou extrajudicial, ser executadas caso o CLIENTE deixe
  de atender qualquer obrigação decorrente de sua operação.

  2.4. O CLIENTE compromete-se a liquidar as operações de empréstimo de ativos, mediante a entrega
  de ativos da mesma espécie, emissor e classe, ajustados aos proventos relativos aos mesmos no
  caso de ações, nas formas previstas nos Normas, e a pagar a taxa de remuneração do empréstimo
  previamente pactuada em cada operação. Caso não seja possível proceder à entrega dos ativos
  tomados em empréstimo em razão da indisponibilidade destes no mercado, poderá a Bolsa determinar
  a liquidação financeira da operação, conforme os dispostos nos Normas.

  2.5. A CORRETORA ficará isenta de qualquer responsabilidade no caso de subscrição não realizada
  no curso da operação de empréstimo, se, avisado, o CLIENTE não lhe colocar à disposição os
  recursos necessários dentro do prazo estabelecido.

  DAS DISPOSIÇÕES GERAIS

  3.1. O CLIENTE declara:

  concordar com as taxas cobradas pela CORRETORA , divulgadas em seu site na rede mundial de
  computadores ( www.easynvest.com.br ), e acompanhá-las regularmente;

  ter conhecimento, acompanhar regularmente e concordar com as informações e especificações do
  produto objeto deste ADITIVO, disponíveis no site da CORRETORA, cujo conteúdo pode ser alterado
  pela CORRETORA, ao seu exclusivo critério, sem a necessidade de aviso prévio ao CLIENTE;

  ter ciência do documento ?Termo de Adesão ao Banco de Títulos BMFBOVESPA?, disponível no site da
  CORRETORA em www.easynvest.com.br, subscrito pela Bolsa e pela CORRETORA, cujas condições
  contratuais serão aplicáveis, no que couber, ao CLIENTE; e

  não estar vedado às operações objeto deste ADITIVO, conforme regulação vigente.

  As presentes cláusulas entram em vigor no ato da celebração deste ADITIVO , permanecendo em
  vigor as demais disposições do CONTRATO DE INTERMEDIAÇÃO .



  O presente ADITIVO está devidamente registrado no 4º Oficial de Registro de Títulos e Documentos
  e Civil de Pessoa Jurídica da Cidade de São Paulo, sob nº 5.217.256.`
}
